export default function () {
  return {
    errors: {},
    customToolbar: [['bold', 'italic', 'underline'], [{ list: 'ordered' }, { list: 'bullet' }], ['image']],
    formattedShowFrom: null,
    formattedShowUntil: null,
    notification: {
      id: null,
      title: '',
      content: '',
      showFrom: null,
      showUntil: null,
      roles: [],
      enabled: true,
    },
  }
}
